import { CHANGE_SELECTED_SALES, CHANGE_SELECTED_LEASES } from '../actions/select_list';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_SELECTED_SALES:
    return { ...state, selectedSaleIds: action.sales };
  case CHANGE_SELECTED_LEASES:
    return { ...state, selectedLeaseIds: action.leases };
  default:
    return state;
  }
}
